import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NewsRecommendItem from "../../components/rich/NewsRecommendItem.vue";
import Classify from "../../components/Classify.vue";
export default {
  name: "NewsRecommend",
  components: {
    NewsRecommendItem: NewsRecommendItem,
    Classify: Classify
  },
  data: function data() {
    return {
      search: {
        classify_id: 0,
        recommend: this.$route.params.id,
        status: 1
      },
      classifyList: []
    };
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var classifyList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$http.get("/api/app/information/classify");

            case 2:
              classifyList = _context.sent;
              classifyList.unshift({
                id: 0,
                name: "全部"
              });
              this.classifyList = classifyList;

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    onClassifyChange: function onClassifyChange(_ref) {
      var value = _ref.value;
      this.search.classify_id = value.item;
      this.$refs.list.searchRefresh();
    }
  }
};